import { useEffect, useState } from 'react';
import { useAlert } from 'react-alert';
import { Modal } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import swal from "sweetalert";
import QuestionLayoutreattempted from '../QuizComponent/QuestionLayout/QuestionLayoutreattempted';

function Prelims({ lessonData, courseData }) {
  const [openModal, setOpenModal] = useState(false);
  const [startTest, setStartTest] = useState(false);
  const [userinput, setuserinput] = useState("");
  const alert = useAlert();


  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    let hasPushed = false;

    const handlePopState = (e) => {
      if (startTest) {
        const confirmed = window.confirm(
          'Are you sure you want to leave this page? Your test progress may be lost.'
        );

        if (!confirmed) {
          // Re-push only once to avoid stacking same page
          if (!hasPushed) {
            window.history.pushState(null, '', location.pathname);
            hasPushed = true;
          }
        } else {
          // If confirmed, go back or fallback
          if (window.history.length > 1) {
            navigate(-2); // go 2 steps back, since 1 is duplicate test page
          } else {
            navigate('/'); // fallback to home
          }
        }
      }
    };

    if (startTest) {
      hasPushed = true;
      window.history.pushState(null, '', location.pathname); // push only once
      window.addEventListener('popstate', handlePopState);
    }

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [startTest, navigate, location.pathname]);

  // useEffect(() => {
  //   const handlePopState = (e) => {
  //     if (startTest) {
  //       // Re-push the current path to lock navigation
  //       window.history.pushState(null, '', window.location.pathname);
  //     }
  //   };

  //   if (startTest) {
  //     window.history.pushState(null, '', window.location.pathname); // Push dummy state
  //     window.addEventListener('popstate', handlePopState);
  //   }

  //   return () => {
  //     window.removeEventListener('popstate', handlePopState);

  //   };
  // }, [startTest]);


  // const [hasScrolled, setHasScrolled] = useState(false);

  useEffect(() => {
    if (window.innerWidth < 768 && startTest) {
      window.scrollTo({ top: 290, behavior: 'smooth' });
    }
  }, [startTest]);

  const hanldeStartQuiz = () => {

    // console.log(lessonData.TestPassword);

    if (lessonData.TestPassword > 0) {
      setOpenModal(true)
    } else {
      setStartTest(true)
    }
  }
  const submitPassword = () => {
    if (userinput == lessonData.TestPassword) {
      setOpenModal(false);
      setStartTest(true);
    } else {
      swal("Incorrect Password", "Please Enter Correct Password", { icon: "error" });
    }
    setuserinput('');
  }

  const viewReportJSX = <Link to={`/course-lesson-result`} state={{ lessonData, courseData }} type="button" className="btn bg-Question-white btn-md ms-md-3 col-md-2" >VIEW REPORT</Link>

  const reAttemptJSX = <button to={`/testseries/finalresult`} type="button" className="btn bg-Question-white btn-md ms-md-3 col-md-2" onClick={hanldeStartQuiz}>REATTEMPT</button>

  const continueJSX = <button type="button" className="btn bg-Question-white btn-md ms-md-3 col-md-2" onClick={hanldeStartQuiz}>CONTINUE</button>

  const startJSX = <button type="button" className="btn bg-Question-white btn-md ms-md-3 col-md-2" onClick={hanldeStartQuiz}>START</button>



  const selectTestStartButtons = () => {
    const allTestsReportsArray = JSON.parse(localStorage.getItem("LessonReportArray"));
    const currentTest = allTestsReportsArray?.find((test) => test.sectionId == lessonData?.SectionID);

    if (currentTest) {
      if (lessonData?.Status == 'Complete') {
        return (
          <>
            {continueJSX}
            {viewReportJSX}
          </>
        )
      } else {
        return (
          <>
            {continueJSX}
          </>

        )
      }

    } else {
      if (lessonData?.Status == 'Complete') {
        if (lessonData?.AttemptCount < lessonData?.TotalAttempt) {
          return (
            <>
              {reAttemptJSX}
              {viewReportJSX}
            </>

          )
        } else {
          return (
            <>
              {viewReportJSX}
            </>

          )
        }
      } else {
        return (
          <>
            {startJSX}
          </>

        )
      }
    }

  }

  const getLeesonData = () => {
    if (lessonData?.Status == 'Complete') {
      return { ...lessonData, reAttempt: true }
    } else if (lessonData?.Status != 'Complete') {
      return { ...lessonData, reAttempt: false }
    } else {
      return lessonData;
    }
  }

  return (
    <>
      {!startTest && <div className="d-flex justify-content-between justify-content-md-start gap-2 align-items-baseline flex-wrap">
        <button
          className={`btn btn-prelims-margin activebuttontabmcq pb-2 pt-2 fs-6`}
          type="button">{courseData.CourseID === '1749468128241YDnrK9x' ? 'MCQs' : 'PT MCQs'}</button>
        {
          selectTestStartButtons()
        }



      </div>}
      {startTest && <><QuestionLayoutreattempted lessonData={getLeesonData()} courseData={courseData} /></>}

      <Modal onHide={setOpenModal} show={openModal} size="md" backdrop="static" centered
        keyboard={false} >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" style={{ color: "#ff5722" }} id="exampleModalLabel">Please Enter Quiz Password to proceed</h5>
            <button type="button" className="btn-close" onClick={() => setOpenModal(false)}></button>
          </div>
          <div className="modal-body pt-3">
            <div className="mb-3 ">
              <label htmlFor="inputPassword" style={{ color: "#303972" }} className="form-label">Password<span className="text-danger">*</span></label>
              <input type="text" class="form-control py-1" value={userinput} onChange={(e) => setuserinput(e.target.value)} id="inputPassword" style={{ textTransform: 'none' }} />
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-danger btn-xs" onClick={() => setOpenModal(false)}>Close</button>
            <button type="button" className="btn btn-xs text-light" onClick={submitPassword} style={{ backgroundColor: "#303972" }}  >Submit</button>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default Prelims;